var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Settings")]),_c('h2',[_vm._v("Notifications")]),_c('NotificationsViewVue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }